<div class="overlay border-primary-2">
  <span [style]="textStyle" class="content">{{ text | translate }}</span>
</div>
